import { Button } from "@/components/ui";
import Input from '@/components/ui/Input/Input';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const FormDataSchema = z.object({
  address: z.string().min(1, 'Address is required'),
  email: z.email('Invalid email address')
});


const FooterContactInfoForm = ({handleSave, handleCancel, data}:{handleSave: (data: {address: string; email: string}) => void; handleCancel: () => void; data: z.infer<typeof FormDataSchema> }) => {
    
    const {
            control,
            handleSubmit,
            formState: { errors },
            reset
          } = useForm({
            resolver: zodResolver(FormDataSchema),
            defaultValues: {
              address: data.address ?? '',
              email: data.email ?? '',
            },
            mode: 'all'
          });
        
    return (
      <div className="flex flex-col gap-4 w-full p-4 lg:p-8 bg-[#F2F2F2]">
        <form onSubmit={handleSubmit(handleSave)} className="flex flex-col gap-4">
          <Controller
          name="address"
          control={control}
          render={({ field }) => (
            <Input
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="Address"
              label="Address"
              error={errors.address?.message}
              $dataId="address-input"
              required
            />
          )}
        />

           <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <Input
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="email@example.com"
              label="Contact Email"
              error={errors.email?.message}
              $dataId="email-input"
              required  
            />
          )}
        />
    

            <div className="flex gap-2 justify-end mt-4">
            <Button
              variant="secondary"
              className=""
              onClick={() => {
                handleCancel();
                reset();
              }}
            >
              Cancel
            </Button>
            <Button
              className=""
              onClick={handleSubmit(handleSave)}
            >
              Save
            </Button>
          </div>
        </form>
      </div>
    )
  };

  export default FooterContactInfoForm;